import { SxProps } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const catalogEntryListCompareCollectorActionsButtonCompareSX: SxProps = {
	ml: '10px',
	backgroundColor: 'primary.main',
	'&:hover': {
		backgroundColor: 'primary.dark',
	},
	borderRadius: '3px',
	p: '8px 10px',
	fontSize: '14px',
	fontWeight: OpenSansFontWeights.bold,
	color: 'white',
	textTransform: 'capitalize',
};
